import React from "react";
import { css, AmountInput, DateInput, CustomDropdown, TextInput, StatusBanner, NotesOnlyCard } from "../components/InvestmentForms/SharedComponents";

const TRANSACTION_OPTIONS = [
    { value: "Purchase of Shares",                label: "Purchase of Shares" },
    { value: "Sale of Shares to Third Party",     label: "Sale of Shares to Third Party" },
    { value: "Buyback by Investee from Investor", label: "Buyback by Investee from Investor" },
    { value: "Subscription to Rights Issue",      label: "Subscription to Rights Issue" },
    { value: "Stock Split by Investee",           label: "Stock Split by Investee" },
    { value: "Bonus Issue by Investee",           label: "Bonus Issue by Investee" },
];

export const BuybackForm = ({ fd, hc, companyOptions, selectedTransaction, onTransactionChange }) => (
    <div style={{
        border: "1px solid #eaeeed",
        borderRadius: "12px",
        padding: "20px",
        backgroundColor: "#fff",
        marginBottom: "16px"
    }}>
        <div style={{ marginBottom: "20px" }}>
            <CustomDropdown
                label="Nature Of Transaction"
                options={TRANSACTION_OPTIONS}
                placeholder="Select Transaction Type"
                value={selectedTransaction}
                onChange={onTransactionChange}
                fullWidth
            />
        </div>
        <div className={css.formContainer}>
            <DateInput label="Transaction Date" value={fd.transactionDate} onChange={v => hc("transactionDate", v)} />
            <CustomDropdown label="Investor Company" options={companyOptions} placeholder="Select Investor" value={fd.investorCompany} onChange={v => hc("investorCompany", v)} />
            <CustomDropdown label="Investee Company" options={companyOptions} placeholder="Select Investee" value={fd.investeeCompany} onChange={v => hc("investeeCompany", v)} />
            <TextInput label="No Of Shares Bought Back" placeholder="Enter No Of Shares" value={fd.noOfSharesBoughtBack} onChange={v => hc("noOfSharesBoughtBack", v)} />
            <AmountInput label="Buyback Price Per Share" value={fd.buybackPricePerShare} onChange={v => hc("buybackPricePerShare", v)} />
            <AmountInput label="Total Buyback Proceeds" value={fd.totalBuybackProceeds} onChange={v => hc("totalBuybackProceeds", v)} />
            <AmountInput label="Cost Of Shares Bought Back" value={fd.costOfSharesBoughtBack} onChange={v => hc("costOfSharesBoughtBack", v)} />
            <AmountInput label="Gain Or Loss" value={fd.gainOrLoss} onChange={v => hc("gainOrLoss", v)} />
            <TextInput label="Buyback Reference / Board Resolution" placeholder="Type something..." value={fd.buybackReference} onChange={v => hc("buybackReference", v)} fullWidth />
        </div>
    </div>
);

const Buyback = ({ formData, onChange, relationship, onRelChange, companyOptions, consolList, selectedTransaction, onTransactionChange }) => (
    <>
        <BuybackForm
            fd={formData}
            hc={onChange}
            companyOptions={companyOptions}
            selectedTransaction={selectedTransaction}
            onTransactionChange={onTransactionChange}
        />
        <StatusBanner relationship={relationship} onRelChange={onRelChange} />
        <NotesOnlyCard formData={formData} onChange={onChange} />
    </>
);

export default Buyback;